import { composeDetailSearchFilter } from 'utils/insightModal/composeDetailSearchFilter'
import { composeDrillDownWidgetSetting } from 'utils/insightModal/composeDrillDownWidgetSetting'
import { SearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/searchFilterComposingStrategy'
import { WidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/widgetSettingComposingStrategy'
import { InsightContentSettingType } from 'components/insightContent/types'
import { FilterTypeStrings } from 'enums/FilterType'
import { getSelectionName } from 'components/insightContent/utils/utils'
import { InsightData } from 'schemas/action/InsightDataSchema'
import AnalysisFilter from 'types/analysisFilter'
import { toFilter } from '../../../../../utils/widgetUtil'
import { SentimentWidgetsType } from '../../types'

export const convertToInsightContentSetting = (
  widgetSetting: SentimentWidgetsType,
  strategy: SearchFilterComposingStrategy,
  selection?: { insights?: Array<InsightData> }
) => {
  const { viewOption } = widgetSetting
  const insights = selection ? selection?.insights : null

  const insightContentSetting = {
    viewOption: viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos: widgetSetting.topicInfos!,
    drillDownTypes: [] as FilterTypeStrings[],
    drillDownFilter: {} as AnalysisFilter,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic?.topicId,
    insights,
    displayTitleTooltip: false
  } as InsightContentSettingType

  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  if (insights && insights.length > 0) {
    insightContentSetting.selectionName = getSelectionName(insights?.[0], viewOption)!
    if (insights.length > 1) {
      if (insights.length === 2) {
        insightContentSetting.selectionSecondName = getSelectionName(insights?.[1], viewOption)!
      }
    }

    insightContentSetting.selectionFilter = composeDetailSearchFilter(
      strategy,
      widgetSetting,
      insights
    )
  }

  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: SentimentWidgetsType,
  strategy: WidgetSettingComposingStrategy,
  selection: { insights?: Array<InsightData> }
) => {
  if (widgetSetting && typeof widgetSetting === 'object') {
    return composeDrillDownWidgetSetting(strategy, widgetSetting, selection.insights!)
  }
  return {}
}
